import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

import {
    PageHeader,
    Panel,
    PrimaryButton,
    SuccessButton,
    InfoRow,
} from "../../../components/ui/AdminUI";

import StatusBadge from "../../../components/ui/StatusBadge";
import DataTable from "../../../components/ui/DataTable";

export default function MyShipmentsPage() {
    const navigate = useNavigate();

    const [shipments, setShipments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadShipments();
    }, []);

    const loadShipments = async () => {
        try {
            const { data } = await api.get("/shipment/my");
            setShipments(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to load shipments."
            );
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            label: "Tracking",
            render: (s) => (
                <b>{s.trackingNumber || "�"}</b>
            ),
        },
        {
            label: "Status",
            render: (s) => (
                <StatusBadge
                    status={s.status || "Created"}
                />
            ),
        },
        {
            label: "Payment",
            render: (s) => (
                <StatusBadge
                    status={s.paymentStatus || "Pending"}
                />
            ),
        },
        {
            label: "Actions",
            render: (s) => {

                const shipmentId = s.id ?? s.shipmentId;
                const orderId = s.orderId;

                const paid =
                    s.paymentStatus === "Completed" ||
                    s.paymentStatus === "Paid";

                return (
                    <div className="flex gap-2 flex-wrap">

                        {orderId && (
                            <PrimaryButton
                                onClick={() =>
                                    navigate(`/client/orders/${orderId}`)
                                }
                            >
                                Order
                            </PrimaryButton>
                        )}

                        {!paid && shipmentId && (
                            <SuccessButton
                                onClick={() =>
                                    navigate(`/payments/create/${shipmentId}?orderId=${orderId}`)
                                }
                            >
                                Pay
                            </SuccessButton>
                        )}

                        {paid && (
                            <PrimaryButton
                                onClick={() =>
                                    window.open(`/api/invoice/${orderId}/pdf`)
                                }
                            >
                                Invoice
                            </PrimaryButton>
                        )}

                    </div>
                );
            },
        },
    ];

    if (loading)
        return <p>Loading...</p>;

    return (
        <div className="space-y-6">

            <PageHeader
                title="My Shipments"
                subtitle="Track shipments and payments."
            />

            {error && (
                <div className="rounded-xl bg-red-50 border border-red-300 p-4 text-red-700">
                    {error}
                </div>
            )}

            <div className="grid md:grid-cols-3 gap-4">

                <Panel title="Shipments">
                    <InfoRow
                        label="Total"
                        value={shipments.length}
                    />
                </Panel>

                <Panel title="Paid">
                    <InfoRow
                        label="Completed"
                        value={
                            shipments.filter(
                                x =>
                                    x.paymentStatus === "Completed" ||
                                    x.paymentStatus === "Paid"
                            ).length
                        }
                    />
                </Panel>

                <Panel title="Pending">
                    <InfoRow
                        label="Waiting"
                        value={
                            shipments.filter(
                                x =>
                                    x.paymentStatus !== "Completed" &&
                                    x.paymentStatus !== "Paid"
                            ).length
                        }
                    />
                </Panel>

            </div>

            <Panel title="Shipment Registry">

                <DataTable
                    columns={columns}
                    rows={shipments}
                    emptyMessage="No shipments found."
                />

            </Panel>

        </div>
    );
}